const columns: TableColumn[] = [
  {
    Header: `Contact ID`,
    accessor: `contactId`,
    dbKey: `contactId`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Location ID`,
    accessor: `locationId`,
    dbKey: `locationId`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Question`,
    accessor: `input`,
    dbKey: `input`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Answer`,
    accessor: `output`,
    dbKey: `output`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Model`,
    accessor: `model`,
    dbKey: `model`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Fallback From`,
    accessor: `fallbackFromModel`,
    dbKey: `fallbackFromModel`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Fallback Reason`,
    accessor: `fallbackReason`,
    dbKey: `fallbackReason`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false,
    // Long free text and empty on most rows — available from the column picker
    // rather than taking width from every view by default.
    defaultHidden: true
  },
  {
    Header: `Tool`,
    accessor: `tool`,
    dbKey: `tool`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Status`,
    accessor: `status`,
    dbKey: `status`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Input Tokens`,
    accessor: `inputTokens`,
    dbKey: `inputTokens`,
    isString: false,
    isNumeric: true,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Output Tokens`,
    accessor: `outputTokens`,
    dbKey: `outputTokens`,
    isString: false,
    isNumeric: true,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Created At`,
    accessor: `createdAt`,
    dbKey: `createdAt`,
    isString: false,
    isNumeric: false,
    isDate: true,
    isBool: false,
    isSortable: true
  }
];

export default columns;
